var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-input-number", {
    attrs: {
      min: _vm.min,
      max: _vm.max
    },
    on: {
      change: _vm.handleChange
    },
    model: {
      value: _vm.num,
      callback: function callback($$v) {
        _vm.num = $$v;
      },
      expression: "num"
    }
  });
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };